<template>
  <b-sidebar
    v-if="isOpenLocal"
    v-model="isOpenLocal"
    id="sidebar-right-bdr2026-solve"
    :title="'Распределение элемента: ' + (conflictLocal.name || '')"
    right
    backdrop
    shadow
    width="65em"
    backdrop-variant="dark"
    no-close-on-backdrop
  >
    <div class="d-block">
      <div class="mb-4">
        <div v-if="loadingList" class="p-3 text-muted text-center">
          <b-spinner small></b-spinner> Загрузка...
        </div>
        <template v-else>
          <template v-if="conflictLocal.list && conflictLocal.list.length > 0">
            <b-table-simple hover small caption-top responsive>
              <caption
                style="font-size: 18px; padding-bottom: 30px; padding-left: 10px;"
              >
                Выберите к какому элементу отнести строку и нажмите сохранить:
                <div v-if="conflictLocal.list[0]">
                  <small
                    >Вычисленное значение:
                    <strong>{{ formatValue(conflictLocal.list[0].value) }}</strong></small
                  >
                </div>
              </caption>
              <b-thead>
                <b-tr>
                  <b-th>Статья (Бюджет)</b-th>
                  <b-th>Признак</b-th>
                  <b-th>Действие</b-th>
                </b-tr>
              </b-thead>
              <b-tbody>
                <b-tr v-for="(item, index) in conflictLocal.list" :key="index">
                  <b-td>{{ item.name }}</b-td>
                  <b-td>{{ item.priznak_line }}</b-td>
                  <b-td class="text-center">
                    <b-button
                      @click="checkSolve(index)"
                      size="sm"
                      :variant="item.checked ? 'success' : 'outline-secondary'"
                      class="ml-2"
                      style="width: 37px; height: 35px;"
                      :disabled="loading"
                    >
                      <b-icon icon="check-lg" scale="1.5"></b-icon>
                    </b-button>
                  </b-td>
                </b-tr>
                <b-tr v-if="globalSearchChosen">
                  <b-td colspan="2">
                    <span class="text-info">Из глобального поиска: {{ globalSearchChosen.displayName }}</span>
                  </b-td>
                  <b-td class="text-center">
                    <b-button
                      size="sm"
                      variant="success"
                      class="ml-2"
                      style="width: 37px; height: 35px;"
                      :disabled="loading"
                    >
                      <b-icon icon="check-lg" scale="1.5"></b-icon>
                    </b-button>
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </template>
          <template v-else>
            <p class="text-muted p-3">
              Добавьте свойство в словаре 1С. После добавления вы сможете привязать строку к статье.
            </p>
          </template>

          <div class="d-flex flex-wrap align-items-center justify-content-end mt-3 mb-2">
            <b-button size="sm" variant="primary" class="mr-2 mb-1" @click="$emit('open-add-property', conflictLocal)">
              Добавить свойство
            </b-button>
            <b-button size="sm" variant="outline-primary" class="mr-2 mb-1" @click="openGlobalSearch">
              Глобальный поиск
            </b-button>
            <b-button size="sm" variant="outline-secondary" class="mb-1" @click="$emit('recalc-row', conflictLocal)">
              Пересчитать свойство
            </b-button>
            <span v-if="globalSearchChosen" class="ml-2 mb-1">
              <b-badge variant="info">Выбрано: {{ globalSearchChosen.displayName }}</b-badge>
              <b-button size="sm" variant="link" class="p-0 ml-1" @click="clearGlobalSearch">сбросить</b-button>
            </span>
          </div>
        </template>
      </div>

      <div class="d-flex mt-2 mb-2">
        <b-button
          size="md"
          class="ml-auto btn btn-secondary"
          @click="closeSidebar()"
          :disabled="loading"
        >
          Отмена
        </b-button>
        <b-button
          size="md"
          class="ml-2 btn btn-primary"
          @click="saveElement()"
          :disabled="!canSave"
        >
          Сохранить
          <b-icon
            v-if="loading"
            icon="arrow-repeat"
            scale="1.2"
            aria-label="Reload"
            :animation="loading ? 'spin' : ''"
          ></b-icon>
        </b-button>
      </div>
    </div>

    <b-modal
      v-model="globalSearchOpen"
      title="Глобальный поиск по словарю 1С"
      size="lg"
      hide-footer
      body-class="p-0"
      @shown="onGlobalSearchShown"
    >
      <div class="p-3 border-bottom">
        <b-form-input
          v-model="globalSearchQuery"
          placeholder="Поиск по свойству из файла или ID..."
          size="sm"
          class="mb-0"
        />
      </div>
      <div class="global-search-list overflow-auto" style="max-height: 60vh;">
        <div v-if="fullDictionaryLoading" class="p-4 text-center text-muted">
          <b-spinner small></b-spinner> Загрузка словаря...
        </div>
        <template v-else>
          <div
            v-for="item in filteredFullDictionary"
            :key="item.id"
            class="global-search-item p-2 px-3 border-bottom cursor-pointer"
            @click="selectFromGlobalSearch(item)"
          >
            <span class="text-dark">{{ item.displayName }}</span>
            <small class="text-muted ml-2">ID: {{ item.id }}</small>
          </div>
          <div v-if="filteredFullDictionary.length === 0" class="p-4 text-muted text-center">
            Ничего не найдено
          </div>
        </template>
      </div>
    </b-modal>
  </b-sidebar>
</template>

<script>
import { API_BDR2026_SAVE_ONE_ELEMENT, API_BDR2026_SEARCH_PROPERTY_VARIANTS, API_BDR2026_1C_DICTIONARY } from '@/constants';

export default {
  name: 'Bdr2026SolveConflicts',
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    conflict: {
      type: Object,
      default: () => ({
        list: [],
        name: '',
        file_name: '',
        r_index: -1
      })
    },
    year: { type: Number, default: 2026 },
    month: { type: Number, default: 1 },
    unit: { type: String, default: 'B2B' },
    refreshTrigger: { type: Number, default: 0 }
  },
  data() {
    return {
      loading: false,
      loadingList: false,
      checkedIndex: -1,
      globalSearchChosen: null,
      globalSearchOpen: false,
      fullDictionaryFlat: [],
      fullDictionaryLoading: false,
      globalSearchQuery: ''
    };
  },
  computed: {
    canSave() {
      if (this.globalSearchChosen) return true;
      const list = this.conflictLocal.list || [];
      return this.checkedIndex >= 0 && this.checkedIndex < list.length;
    },
    filteredFullDictionary() {
      const q = (this.globalSearchQuery || '').toLowerCase().trim();
      if (!q) return this.fullDictionaryFlat;
      return this.fullDictionaryFlat.filter(
        (item) =>
          (item.name_from_file && item.name_from_file.toLowerCase().indexOf(q) !== -1) ||
          (item.displayName && item.displayName.toLowerCase().indexOf(q) !== -1) ||
          String(item.id).indexOf(q) !== -1
      );
    },
    isOpenLocal: {
      get() {
        return this.isOpen;
      },
      set(value) {
        this.$emit('update:isOpen', value);
      }
    },
    conflictLocal: {
      get() {
        return this.conflict;
      },
      set() {}
    }
  },
  watch: {
    isOpen(val) {
      if (val) {
        this.checkedIndex = -1;
        this.globalSearchChosen = null;
        this.loadingList = true;
        this.fetchFreshList();
      }
    },
    refreshTrigger() {
      if (this.isOpen) {
        this.fetchFreshList();
      }
    }
  },
  methods: {
    fetchFreshList() {
      const c = this.conflict;
      if (!c || !c.file_name || c.r_index == null) return;
      this.loadingList = true;
      const url = `${API_BDR2026_SEARCH_PROPERTY_VARIANTS}?file_name=${encodeURIComponent(c.file_name)}&file_row=${c.r_index}&year=${this.year}&month=${this.month}&unit=${encodeURIComponent(this.unit)}`;
      axios.get(url).then(({ data }) => {
        const list = Array.isArray(data.list) ? data.list : [];
        const fault = data.fault || null;
        this.$emit('update:conflict', {
          ...c,
          list,
          fault: fault || c.fault
        });
        this.loadingList = false;
      }).catch(() => {
        this.loadingList = false;
      });
    },
    formatValue(val) {
      if (val == null || val === '') return '—';
      const n = Number(val);
      if (Number.isNaN(n)) return String(val);
      return new Intl.NumberFormat('ru-RU', { style: 'decimal', minimumFractionDigits: 2 }).format(n) + ' р.';
    },
    closeSidebar() {
      this.isOpenLocal = false;
    },
    checkSolve(index) {
      this.globalSearchChosen = null;
      if (this.checkedIndex !== index) {
        this.checkedIndex = index;
      } else {
        this.checkedIndex = -1;
      }
      (this.conflictLocal.list || []).forEach((element, e_key) => {
        element.checked = e_key === this.checkedIndex;
      });
    },
    openGlobalSearch() {
      this.globalSearchOpen = true;
    },
    onGlobalSearchShown() {
      if (this.fullDictionaryFlat.length === 0) {
        this.loadFullDictionary();
      }
    },
    loadFullDictionary() {
      this.fullDictionaryLoading = true;
      const url = `${API_BDR2026_1C_DICTIONARY}?easylist=1`;
      axios.get(url).then(({ data }) => {
        const list = Array.isArray(data) ? data : [];
        this.fullDictionaryFlat = list.map((entry) => this.buildOneCItem(entry));
        this.fullDictionaryLoading = false;
      }).catch(() => {
        this.fullDictionaryLoading = false;
      });
    },
    buildOneCItem(entry) {
      const hasSplits = entry.splits && entry.splits.length > 0;
      let priznak;
      let displayName;
      if (hasSplits) {
        priznak = entry.splits.map((s) => ({
          unit: s.unit || 'B2B',
          perc: parseFloat(s.perc) || 100,
          bdr2026_dictionary_id: s.bdr2026_dictionary_id || entry.bdr2026_dictionary_id
        }));
        const parts = entry.splits.map((s) => (s.dictionary && s.dictionary.name) ? `${s.perc}% ${s.unit} → ${s.dictionary.name}` : '');
        displayName = (entry.name_from_file || '') + (parts.length ? ' — ' + parts.join(', ') : '');
      } else {
        const dictId = entry.bdr2026_dictionary_id;
        const name = (entry.property && entry.property.name) || (entry.dictionary && entry.dictionary.name) || '';
        const parsed = this.parseUnitPercent(entry.unit_percent || '100%B2B');
        priznak = parsed.length
          ? parsed.map((u) => ({ unit: u.unit, perc: u.perc, bdr2026_dictionary_id: dictId }))
          : [{ unit: this.unit, perc: 100, bdr2026_dictionary_id: dictId }];
        displayName = (entry.name_from_file || '') + (name ? ' — ' + name : '');
      }
      return {
        id: entry.id,
        name_from_file: entry.name_from_file,
        priznak,
        displayName: displayName || entry.name_from_file || 'ID: ' + entry.id
      };
    },
    selectFromGlobalSearch(item) {
      this.globalSearchChosen = { id: item.id, displayName: item.displayName, priznak: item.priznak };
      this.checkedIndex = -1;
      (this.conflictLocal.list || []).forEach((el) => { el.checked = false; });
      this.globalSearchOpen = false;
    },
    clearGlobalSearch() {
      this.globalSearchChosen = null;
    },
    parseUnitPercent(str) {
      const value = (str || '').trim().replace(/[\s\-;:]/g, '');
      if (!value) return [];
      const units = [];
      value.split(',').forEach((part) => {
        if (!part) return;
        const p = part.split('%');
        if (p.length === 1) units.push({ perc: 100, unit: (p[0] || '').trim() });
        else units.push({ perc: parseFloat(p[0]) || 0, unit: (p[1] || '').trim() });
      });
      return units.filter((u) => u.unit && ['B2B', 'B2C', 'БСЗ'].includes(u.unit));
    },
    saveElement() {
      const list = this.conflictLocal.list || [];
      const c = this.conflictLocal;
      let addBdr;

      if (this.globalSearchChosen) {
        const value = (list[0] && list[0].value != null) ? list[0].value : (c.fault && c.fault.value != null ? c.fault.value : 0);
        const priznak = this.globalSearchChosen.priznak && this.globalSearchChosen.priznak.length
          ? this.globalSearchChosen.priznak.map((p) => ({ unit: p.unit, perc: p.perc, bdr2026_dictionary_id: p.bdr2026_dictionary_id }))
          : [{ perc: 100, unit: this.unit, bdr2026_dictionary_id: this.globalSearchChosen.id }];
        addBdr = {
          bdr2026_dictionary_id: priznak[0] && priznak[0].bdr2026_dictionary_id,
          value: value,
          priznak,
          file_name: c.file_name,
          file_row: c.r_index,
          year: this.year,
          month: this.month
        };
      } else {
        if (this.checkedIndex < 0 || this.checkedIndex >= list.length) return;
        const chosen = list[this.checkedIndex];
        addBdr = {
          bdr2026_dictionary_id: chosen.bdr2026_dictionary_id,
          value: chosen.value,
          priznak: chosen.priznak && chosen.priznak.length
            ? chosen.priznak.map(p => ({ unit: p.unit, perc: p.perc, bdr2026_dictionary_id: p.bdr2026_dictionary_id }))
            : [{ perc: 100, unit: 'B2B', bdr2026_dictionary_id: chosen.bdr2026_dictionary_id }],
          file_name: chosen.file_name || c.file_name,
          file_row: chosen.file_row != null ? chosen.file_row : c.r_index,
          year: chosen.year,
          month: chosen.month
        };
      }

      this.loading = true;
      axios
        .post(API_BDR2026_SAVE_ONE_ELEMENT, { addBdr })
        .then(() => {
          this.$emit('update-otchet', c.file_name, c.r_index);
          this.loading = false;
          this.closeSidebar();
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
.global-search-item:hover {
  background-color: #f0f4f8;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
